import React, { useState } from 'react'
import { Box, Collapse, Paper, Typography } from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { KPI_SECTION_CARD_SX } from '../helpers/kpiCardsSection'

export default function KpiCollapsibleSection({ title, children, defaultExpanded = false, sx = {} }) {
  const [open, setOpen] = useState(defaultExpanded)

  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        ...KPI_SECTION_CARD_SX,
        mb: 0,
        ...sx
      }}
    >
      <Box
        component="button"
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={`${open ? 'Ocultar' : 'Mostrar'} sección ${title}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: 1,
          px: 2,
          py: 1.5,
          m: 0,
          border: 0,
          bgcolor: 'transparent',
          cursor: 'pointer',
          textAlign: 'left',
          font: 'inherit',
          color: 'inherit'
        }}
      >
        <Typography component="span" fontWeight={700} sx={{ flex: 1, minWidth: 0 }}>
          {title}
        </Typography>
        <ExpandMore
          aria-hidden
          sx={{
            color: 'text.secondary',
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: (theme) => theme.transitions.create('transform', { duration: 200 })
          }}
        />
      </Box>
      <Collapse in={open} timeout="auto">
        <Box sx={{ px: 2, pb: 2, pt: 0 }}>{children}</Box>
      </Collapse>
    </Paper>
  )
}
